import { ApiChainSymbols } from '../enums';

export default function getTxHashById(
  txId: string,
  blockchain: ApiChainSymbols
) {
  if (blockchain === ApiChainSymbols.SOL) {
    return txId;
  }

  const splittedTxId = txId.split('/');
  const indexOfTheTxHash = 1;
  return splittedTxId[indexOfTheTxHash] || '';
}
